import React, { ReactNode } from "react";
import { colors } from "./variable";
import { RavenPortal,} from "./Portal";
import RavenPortalComponent from "./RavenPortalComponent";

type TooltipPosition =
  | "top"
  | "top-center"
  | "top-right"
  | "top-left"
  | "left"
  | "bottom-right"
  | "bottom-left"
  | "right";
export interface TooltipProps {
  color?: colors["value"];
  text?: string;
  position?: TooltipPosition;
  big?: any;
  className?: any;
  title?: any;
  downText?: any;
  img?: any;
  textColor?: colors["value"];
  hoverClassName?: string;
  tooltipClassName?: string;
  children?: ReactNode;
  portalId?: string;
  zIndex?: string | number;
}

const RavenToolTip: React.FC<TooltipProps> = ({
  color,
  text,
  position,
  big,
  className,
  title,
  downText,
  img,
  textColor,
  hoverClassName,
  tooltipClassName,
  children,
  zIndex,
  portalId,
}) => {
  if (!big && hoverClassName) {
    return (
      <div className={`tooltip-hover-wrap ${hoverClassName}`} style={{zIndex: zIndex ? zIndex : ""}}>
        <div
          className={`tool-tip-wrap tool-tip-wrap__${color} tool-tip-wrap_${position}`}
        >
          {text && (
            <p
              // style={{ color: "#ffffff" }}
              className={`text text-${textColor}`}
            >
              {text}
            </p>
          )}
        </div>
      </div>
    );
  }
  if (big && hoverClassName) {
    return (
      <div
        style={{ position: "relative", cursor: "pointer", zIndex: zIndex ? zIndex : "" }}
        className={`tooltip-hover-wrap ${hoverClassName}`}
      >
        {children}
        <div
          className={`tool-tip-wrap tool-tip_mascot tool-tip-wrap_big  tool-tip-wrap__${color} tool-tip-wrap_${position} ${className}`}
        >
          {img && (
            <figure className="img-box">
              <img src={img} alt="" className="img" />
            </figure>
          )}
          {title && (
            <p
              //   style={{ color: !textColor && "#ffffff" }}
              className={`title text-${textColor}`}
            >
              {title}
            </p>
          )}
          {text && (
            <p
              //   style={{ color: !textColor && "#ffffff" }}
              className={`text text-${textColor}`}
            >
              {text}
            </p>
          )}
          {downText && (
            <p
              //   style={{ color: !textColor && "#ffffff" }}
              className={`got text-${textColor}`}
            >
              {downText}
            </p>
          )}
        </div>
      </div>
    );
  }
  if (big) {
    return (
      <div
        className={`tool-tip-wrap tool-tip_mascot tool-tip-wrap_big  tool-tip-wrap__${color} tool-tip-wrap_${position} ${className}`}
        style={{zIndex: zIndex ? zIndex : ""}}
      >
        {img && (
          <figure className="img-box">
            <img src={img} alt="" className="img" />
          </figure>
        )}
        {title && (
          <p
            //   style={{ color: !textColor && "#ffffff" }}
            className={`title text-${textColor}`}
          >
            {title}
          </p>
        )}
        {text && (
          <p
            //   style={{ color: !textColor && "#ffffff" }}
            className={`text text-${textColor}`}
          >
            {text}
          </p>
        )}
        {downText && (
          <p
            //   style={{ color: !textColor && "#ffffff" }}
            className={`got text-${textColor}`}
          >
            {downText}
          </p>
        )}
      </div>
    );
  }

  return (
    <>
    {portalId ? (
      <>
      <RavenPortalComponent >
          <div
          className={`tool-tip-wrap tool-tip-wrap__${color} tool-tip-wrap_${position} ${tooltipClassName}`}
          style={{ zIndex: zIndex ? zIndex : "" }}
        >
            {text ||
              (children && (
                <p
                  // style={{ color: "#ffffff" }}
                  className={`text text-${textColor}`}
                >
                  {text}
                  {children}
                </p>
            ))}
        </div>
      </RavenPortalComponent>

    </>):
    (<>
      <div
      className={`tool-tip-wrap tool-tip-wrap__${color} tool-tip-wrap_${position} ${tooltipClassName}`}
      style={{ zIndex: zIndex ? zIndex : "" }}
    >
        {text ||
          (children && (
            <p
              // style={{ color: "#ffffff" }}
              className={`text text-${textColor}`}
            >
              {text}
              {children}
            </p>
        ))}
    </div>
    </>)}
    </>
  );
};

export default RavenToolTip;
